/**
 * Every page of a Data Gateway list, one request per page. An export passes a `maxRows` bound so a
 * huge filter can't hang the browser; a list the app groups or totals itself (a rollup, a calendar)
 * leaves it unbounded, since a missing page would silently skew it. Page with a stable `order`, or
 * rows can repeat or go missing between pages.
 */
export const fetchAllPages = async <T>(
  fetchPage: (pageNo: number, pageSize: number) => Promise<{ items: T[]; totalCount: number }>,
  pageSize = 200,
  maxRows = Number.POSITIVE_INFINITY
): Promise<T[]> => {
  const all: T[] = [];
  for (let pageNo = 1; all.length < maxRows; pageNo += 1) {
    const page = await fetchPage(pageNo, pageSize);
    all.push(...page.items);
    if (page.items.length < pageSize || all.length >= page.totalCount) break;
  }
  return all.slice(0, maxRows);
};
